import React, { useState } from "react";
import { constrainLength } from "../utils/form";
import { XIcon } from "@heroicons/react/solid";

const MAX_CHARS = {
  menu_item_label: 20,
  menu_item_price: 8,
  menu_item_discount: 2,
};

function EditMenuItemPopup({
  close,
  menuItemData,
  currentMenu,
  setCurrentMenu,
}) {
 
  const { item_uuid, category_uuid } = menuItemData;
  const DEFAULT_VALUES = {
    menu_item_label: menuItemData.menu_item_label
      ? menuItemData.menu_item_label
      : "",
    menu_item_price: menuItemData.menu_item_price
      ? menuItemData.menu_item_price
      : "",
    menu_item_discount: menuItemData.menu_item_discount
      ? menuItemData.menu_item_discount
      : "",
    menu_item_description: menuItemData.menu_item_description
      ? menuItemData.menu_item_description
      : "",
    menu_item_parcel_charge: menuItemData.menu_item_parcel_charge
      ? menuItemData.menu_item_parcel_charge
      : "",
  };
  const [data, setData] = useState(DEFAULT_VALUES);

  const handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    const isNumber = Object.keys(MAX_CHARS).includes(name);
    const constrainedValue = isNumber
      ? constrainLength(String(value), MAX_CHARS[name])
      : value;

    setData({
     
      [event.target.name]: constrainedValue,
    });
  };

  // Editing current menu in menu.category_and_items[].menu_items collection
  const handleMenuEdit = async (e) => {
    e.preventDefault();
    await setCurrentMenu({
      ...currentMenu,
      category_and_items: currentMenu.category_and_items.map((a) => {
        if (a.category_uuid === category_uuid) {
          return {
            ...a,
            menu_items: a.menu_items.map((c) => {
              if (c.item_uuid === item_uuid) {
                return {
                  ...c,
                  ...data,
                };
              } else return c;
            }),
          };
        } else return a;
      }),
    });
    console.log(currentMenu,data)
    close()
  };


  return (
    <div className='newCategory'>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Edit</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <form className='newCatContainer2'>
          {menuItemData?.menu_item_label && (
            <div className='cat-inp'>
              <label htmlFor='menu_item_label'>Item Label</label>
              <input
                value={data.menu_item_label}
                onChange={(e) => handleChange(e)}
                type='text'
                name='menu_item_label'
              />
            </div>
          )}
          {menuItemData?.menu_item_price && (
            <div className='cat-inp'>
              <label htmlFor='menu_item_price'>Item Price</label>
              <input
                value={data.menu_item_price}
                onChange={(e) => handleChange(e)}
                min='0'
                type='number'
                name='menu_item_price'
              />
            </div>
          )}
          {menuItemData?.menu_item_discount && (
            <div className='cat-inp'>
              <label htmlFor='menu_item_discount'>Item Discount</label>
              <input
                value={data.menu_item_discount}
                onChange={(e) => handleChange(e)}
                min='0'
                type='number'
                name='menu_item_discount'
              />
            </div>
          )}
          {menuItemData?.menu_item_description && (
            <div className='cat-inp'>
              <label htmlFor='menu_item_description'>Item Description</label>
              <input
                value={data.menu_item_description}
                onChange={(e) => handleChange(e)}
                min='0'
                type='text'
                name='menu_item_description'
              />
            </div>
          )}
          {menuItemData?.menu_item_parcel_charge && (
            <div className='cat-inp'>
              <label htmlFor='menu_item_parcel_charge'>
                Menu Item Parcel Charge
              </label>
              <input
                value={data.menu_item_parcel_charge}
                onChange={(e) => handleChange(e)}
                min='0'
                type='text'
                name='menu_item_parcel_charge'
              />
            </div>
          )}
          <button onClick={handleMenuEdit}>Save</button>
        </form>
      </div>
    </div>
  );
}
export default EditMenuItemPopup;
